import React from 'react';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';
import { SectionTitle } from 'apps/group/styles';
import { FormWrapperDiv } from 'libs/forms/styles';
import { Divider, Center } from 'legacyComponents/styled/lib';
import { ButtonStyled } from 'apps/project/styles';
import { clientStore } from 'apps/client/app';
import { Paragraph, Spinner } from 'components';

export const DeleteProjectSection = observer(({ manager }) => {
  const { projectApp } = manager;
  let deleteAction = (
    <Paragraph>
      <Trans>Please speak to an admin to delete this project.</Trans>
    </Paragraph>
  );
  if (manager.canDelete) {
    deleteAction = (
      <>
        <Paragraph>
          <Trans>
            Once you delete a project, there is no going back. Please be
            certain.
          </Trans>
        </Paragraph>
        <Center>
          <ButtonStyled
            text={<Trans>Delete Project</Trans>}
            onClick={manager.BeginDelete}
            marginTop='10px'
            marginBottom='20px'
            variant='destructive'
            outline
            data-testid='projectPage-deleteProject-button'
          />
        </Center>
      </>
    );
    if (projectApp.deleting) {
      deleteAction = (
        <>
          <Paragraph>
            <Trans>There is no going back...</Trans>
          </Paragraph>
          <Center>
            <ButtonStyled
              text={<Trans>Cancel</Trans>}
              variant='secondary'
              onClick={manager.CancelDelete}
              size='small'
              outline
            />
            <ButtonStyled
              text={<Trans>Confirm Delete</Trans>}
              onClick={manager.ConfirmDelete}
              size='small'
              data-testid='projectPage-confirmDeleteProject-button'
            />
          </Center>
        </>
      );
      if (projectApp.performingDelete) {
        deleteAction = <Spinner margin='30px auto' />;
      }
    }
    return (
      <div className='flex screen1160:justify-center'>
        <div
          className={`flex flex-col ${
            clientStore.windowWidth < 1160 ? 'w-full' : 'w-1/2'
          }`}
        >
          <SectionTitle level={2} size='medium' danger>
            <Trans>Danger Zone</Trans>
          </SectionTitle>
          <Divider width='100%' />
          <FormWrapperDiv responsive>
            <Paragraph>
              <strong>
                {projectApp.deleting ? (
                  <Trans>Are you sure you want to delete this Project?</Trans>
                ) : (
                  <Trans>Delete this Project</Trans>
                )}
              </strong>
            </Paragraph>
            {deleteAction}
          </FormWrapperDiv>
        </div>
      </div>
    );
  }
  return '';
});
